import React, { useRef, useLayoutEffect } from "react"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Div from "../div/div.component"

import {
  DiscordConversationContainer,
  BackgroundPhoneImage,
  LeftConversationContainer,
  RightConversationContainer,
  ProfileImage,
  TextContainer,
  TextHashContainer,
  HashContainer,
} from "./discord-conversation.styles"

const DiscordConversation = (props) => {
  const discordContainerRef = useRef()
  const gsapDiscordQuery = gsap.utils.selector(discordContainerRef)
  const discordTimeline = useRef()
  const images = props.newCommunityAssets

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    discordTimeline.current = gsap
      .timeline({
        scrollTrigger: {
          trigger: discordContainerRef.current,
          start: "-=550",
          //markers: true,
        },
      })
      .from(gsapDiscordQuery(".conversation-1"), {
        y: 60,
        opacity: 0,
        duration: 0.5,
        ease: "none",
      })
      .from(gsapDiscordQuery(".conversation-2"), {
        delay: 0.5,
        y: 50,
        opacity: 0,
        duration: 0.7,
        ease: "none",
      })
    return () => {
      if (discordTimeline.current) discordTimeline.current.kill()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <DiscordConversationContainer ref={discordContainerRef} {...props}>
      <BackgroundPhoneImage
        src={`${images[0].file.url}?w=1500`}
        alt={"background phone"}
        width={382}
        height={680}
        loading="lazy"
      />
      <RightConversationContainer>
        <Div
          className="conversation-1"
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
        >
          <ProfileImage
            src={`${images[1].file.url}?w=65&fm=webp`}
            alt={images[1].title}
            width={75}
            height={75}
            logo={true}
            loading="lazy"
          />
          <TextContainer mt={12} style={{ width: "85%" }} isStudent={true} >
            Hi! I have an online technical interview this week... what should I
            expect and be prepared for? 😰
          </TextContainer>
        </Div>
        <HashContainer ml={["100px", "50px", "200px", "100px"]}>
          <TextHashContainer>#dev-resources</TextHashContainer>
          <TextHashContainer>#portfolios</TextHashContainer>
          <TextHashContainer>#job-hunting</TextHashContainer>
          <TextHashContainer>+ more</TextHashContainer>
        </HashContainer>
      </RightConversationContainer>

      <LeftConversationContainer className="conversation-2">
        <ProfileImage
          src={`${images[2].file.url}?w=75&fm=webp`}
          alt={images[2].title}
          width={75}
          height={75}
          loading="lazy"
        />
        <TextContainer mt={12} isStudent={false}>
          Reach out to the recruiter for any details then checkout my workshop
          on technical interview prep! Happy to help further!
        </TextContainer>
      </LeftConversationContainer>
    </DiscordConversationContainer>
  )
}

export default DiscordConversation
